import styled from '@emotion/styled';
import { useAtomValue, useUpdateAtom } from 'jotai/utils';
import { FC, useMemo } from 'react';
import { product_type_atom, set_is_completed_write_atom, PRODUCT_TYPE, issued_point_atom } from '../../store/write';
import { Button } from 'components/base/Button';
import { IconPoint60, IconReview32 } from 'components/base/Icon';
import Text from 'components/base/Text';
import BottomSheet from 'components/common/BottomSheet';
import { pink_primary } from 'styles';

interface Props {
  is_show: boolean;
  close: () => void;
}

/**
 * 리뷰 작성 완료 바텀싯
 * @component
 */
const CompletedBottomSheet: FC<Props> = ({ is_show, close }) => {
  const setShowCompletedDialog = useUpdateAtom(set_is_completed_write_atom);
  const product_type = useAtomValue(product_type_atom);
  const issued_point = useAtomValue(issued_point_atom);

  const description = useMemo(() => {
    const default_message = '10,000원 미만 상품의 리뷰 포인트로 \n 100P가 지급될 예정이에요.';

    if (product_type === PRODUCT_TYPE.BASE_PRICE) {
      return default_message;
    }

    if (product_type === PRODUCT_TYPE.MIN_PRICE) {
      return '아쉽지만 3,000원 미만 상품은 \n 리뷰 포인트를 지급해 드리지 않고 있어요.';
    }

    return (
      {
        100: '리뷰 50자 미만 작성 리뷰 포인트로 \n 100P가 지급될 예정이에요.',
        150: '리뷰 50자 이상 작성 리뷰 포인트로 \n 150P가 지급될 예정이에요.',
        300: '포토 리뷰 포인트로 300P가 지급될 예정이에요.',
      }[issued_point] ?? default_message
    );
  }, [product_type, issued_point]);

  const handleClose = () => {
    setShowCompletedDialog(false);
    close();
  };

  return (
    <BottomSheet active={is_show}>
      <SC.Container>
        {product_type === PRODUCT_TYPE.MIN_PRICE ? (
          <IconReview32 width={60} height={60} color={pink_primary} />
        ) : (
          <IconPoint60 width={60} height={60} color={pink_primary} />
        )}
        {product_type === PRODUCT_TYPE.MIN_PRICE ? (
          <Text variant='title3_bold' mt={8} alignment='center'>
            리뷰를 작성했어요
          </Text>
        ) : (
          <Text variant='title3_bold' mt={8} alignment='center'>
            리뷰 작성으로 <label className='point'>{issued_point}P</label>가 지급돼요
          </Text>
        )}
        <Text variant='body3' color='gray_secondary' mt={8} alignment='center'>
          {description} <br />
          {product_type !== PRODUCT_TYPE.MIN_PRICE && '적립 완료까지 최대 20분이 소요될 수 있어요.'}
        </Text>
      </SC.Container>
      <SC.ButtonWrapper>
        <Button onClick={handleClose} variant='tertiary_gray' fill>
          닫기
        </Button>
      </SC.ButtonWrapper>
    </BottomSheet>
  );
};

export default CompletedBottomSheet;

const SC = {
  Container: styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0 24px;
    white-space: pre-wrap;

    .point {
      color: ${pink_primary};
    }
  `,
  ButtonWrapper: styled.div`
    padding: 8px 16px;
    width: 100%;
    margin-top: 24px;
  `,
};
